import { fontFamily } from "src/global.style";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 288px;
  min-height: 265px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 24px 38px;

  border-radius: 7.601px;
  border: 0.95px solid var(--Stroke, rgba(241, 243, 247, 0.80));
  background: '#fff';

  box-shadow: 0px 0px 19px -3px rgba(13, 13, 13, 0.09);

  @media(max-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
  }

  @media(max-width: 767px) {
    margin-top: 10px;
    margin-bottom: 20px;
  }
`;
export const Image = styled.div`
  overflow: hidden;
  width: 60px;
  height: 60px;

  img {
    width: 100%;
    max-width: 16.125rem;
  }
`;
export const Title = styled.div`
  font-weight: 500;
  font-size: 16.0808px;
  line-height: 26px;
  color: #230C87;
  font-family: 'Platform Web';
`;

export const Description = styled.p`
  width: 100%;
  font-family: ${fontFamily.neutral};
  font-size: 12.865px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  opacity: 0.7;
  color: #230C87;
`;

export const ContainerFooter = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
`

export const LinkFooter = styled.a`
  opacity: 0.7;
  color: #230C87;
  font-family: "Work Sans";
  font-size: 12.865px;
  font-style: normal;
  font-weight: 700;
  line-height: 142.8%;
  text-decoration-line: underline;
`
